// The back office is one build for staging and production, so its look follows what /me says.
// Staging holds a copy of production's data: orange there, purple for a local or mock run, and the
// zeres green of main.js only for production or when /me has not answered.
import { updatePreset } from '@primeuix/themes';

// The names are AppConfig's primary colours and the layout's body backgrounds, so the config panel
// and the page background follow the same switch AppConfig makes when a colour is picked there.
const colours: Record<string, { name: string; palette: Record<number, string> }> = {
    Staging: { name: 'orange', palette: { 50: '#fff7ed', 100: '#ffedd5', 200: '#fed7aa', 300: '#fdba74', 400: '#fb923c', 500: '#f97316', 600: '#ea580c', 700: '#c2410c', 800: '#9a3412', 900: '#7c2d12', 950: '#431407' } },
    Development: { name: 'purple', palette: { 50: '#faf5ff', 100: '#f3e8ff', 200: '#e9d5ff', 300: '#d8b4fe', 400: '#c084fc', 500: '#a855f7', 600: '#9333ea', 700: '#7e22ce', 800: '#6b21a8', 900: '#581c87', 950: '#3b0764' } }
};

/**
 * Switches the primary palette for a non-production environment and answers the colour's name, for
 * the layout's primary and body background; production and null keep the default and answer null.
 */
export function applyEnvironmentTheme(environment: string | null): string | null {
    const colour = environment ? colours[environment] : undefined;
    if (!colour) return null;
    updatePreset({ semantic: { primary: colour.palette } });
    return colour.name;
}

/** The tag the topbar shows, or null for production and while /me is unknown. */
export function environmentTag(environment: string | null): string | null {
    return environment && environment !== 'Production' ? environment : null;
}
